// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2023 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import GetContactIdMappingsRequestModel from '../../model/get-contact-id-mappings-request-model';
import GetContactIdMappingsRequestDTO from '../dto/get-contact-id-mappings-request-dto';

export default abstract class GetContactIdMappingsRequestModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<GetContactIdMappingsRequestDTO>) {
    super();
    if (data) {
      this.foreignAppSystemIdCriteria = data.foreignAppSystemIdCriteria;
      this.crmStatusIdCriteria = data.crmStatusIdCriteria;
      this.mappingStatusIdCriteria = data.mappingStatusIdCriteria;
      this.searchCriteria = data.searchCriteria;
      this['paging.CurrentPage'] = data['paging.CurrentPage'];
      this['paging.PageSize'] = data['paging.PageSize'];
      this['paging.IncludeCount'] = data['paging.IncludeCount'];
      this['paging.NoPaging'] = data['paging.NoPaging'];
    }
  }
  /**
  * @type {int64}
  */
  'foreignAppSystemIdCriteria'?: number;
  /**
  * @type {int32}
  */
  'crmStatusIdCriteria'?: number;
  /**
  * @type {int32}
  */
  'mappingStatusIdCriteria'?: number;
  /**
  */
  'searchCriteria'?: string;
  /**
  * @type {int32}
  */
  'paging.CurrentPage'?: number;
  /**
  * @type {int32}
  */
  'paging.PageSize'?: number;
  /**
  */
  'paging.IncludeCount'?: boolean;
  /**
  */
  'paging.NoPaging'?: boolean;

  static toModel(dto: DeepPartial<GetContactIdMappingsRequestDTO>): GetContactIdMappingsRequestModel;
  static toModel(dto: DeepPartial<GetContactIdMappingsRequestDTO> | undefined | null): GetContactIdMappingsRequestModel | undefined;
  static toModel(dto: DeepPartial<GetContactIdMappingsRequestDTO> | undefined | null): GetContactIdMappingsRequestModel | undefined {
    return dto ? new GetContactIdMappingsRequestModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<GetContactIdMappingsRequestModel> | GetContactIdMappingsRequestModel) {
    const unwrapped = unwrapDataRecord(model);
    return {
      'foreignAppSystemIdCriteria': unwrapped.foreignAppSystemIdCriteria,
      'crmStatusIdCriteria': unwrapped.crmStatusIdCriteria,
      'mappingStatusIdCriteria': unwrapped.mappingStatusIdCriteria,
      'searchCriteria': unwrapped.searchCriteria,
      'paging.CurrentPage': unwrapped['paging.CurrentPage'],
      'paging.PageSize': unwrapped['paging.PageSize'],
      'paging.IncludeCount': unwrapped['paging.IncludeCount'],
      'paging.NoPaging': unwrapped['paging.NoPaging'],
    } as GetContactIdMappingsRequestDTO;
  }
}
